import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';

import { Subcontent, AntdButton as Button } from '@yuhuinc/ui-library/';

import { LeaseIncentiveForm } from './LeaseIncentiveForm';
import { LeaseIncentive } from './LeaseIncentive';
import { getTranslatedString } from 'helpers/i18n';
import { sizes } from 'helpers/MediaHelper';

const StyledSubcontentContainer = styled.div`
  margin-bottom: 16px;
  width: 100%;
`;

const StyledButton = styled(Button)`
  margin-bottom: 16px;
`;

const LeaseIncentiveList = ({
  selectedLeaseStartDate,
  selectedEarlyMoveInDate,
  setValidIncentives,
  validIncentives,
  leaseDraftLeaseIncentives,
}) => {
  const [toggleNewItem, setToggleNewItem] = useState(false);
  const [incentiveForEdit, setIncentiveForEdit] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [editIndex, setEditIndex] = useState();
  const [isDelete, setDelete] = useState(false);

  const isMobile = window.matchMedia(`(max-width: ${sizes.mobile}px)`).matches;

  useEffect(() => {
    if (leaseDraftLeaseIncentives && validIncentives.length === 0) {
      if (!isDelete) {
        setValidIncentives(leaseDraftLeaseIncentives);
      }
    }
  }, [leaseDraftLeaseIncentives, validIncentives, setValidIncentives, isDelete]);

  const handleEdit = (incentive, index) => {
    setToggleNewItem(true);
    setIsEdit(true);
    setIncentiveForEdit(incentive);
    setEditIndex(index);
  };

  const handleDelete = (index) => {
    let newValidIncentives = [...validIncentives];
    newValidIncentives.splice(index, 1);
    setValidIncentives(newValidIncentives);
    setDelete(true);
  };

  const resetAfterEdit = () => {
    setIsEdit(false);
    setIncentiveForEdit({});
    setEditIndex(undefined);
  };

  return (
    <React.Fragment>
      {!isEmpty(validIncentives) &&
        validIncentives.map((incentive, index) => {
          if (isEdit && index === editIndex) return null;
          return (
            <StyledSubcontentContainer>
              <Subcontent
                label={`${getTranslatedString(
                  'landlordPortal.leaseCreatorV2.leaseIncentivesPage.incentives'
                )} ${index + 1}`}
                onEditClick={() => handleEdit(incentive, index)}
                onDeleteClick={() => handleDelete(index)}
                hideEdit={toggleNewItem || isEdit} // hide edit icon if currently adding or editting
              >
                <LeaseIncentive incentive={incentive} />
              </Subcontent>
            </StyledSubcontentContainer>
          );
        })}

      {toggleNewItem ? (
        <StyledSubcontentContainer>
          <Subcontent
            label={getTranslatedString(
              'landlordPortal.leaseCreatorV2.leaseIncentivesPage.incentives'
            )}
            hideEdit
            hideDelete
            isMobile={isMobile}
          >
            <LeaseIncentiveForm
              setToggleNewItem={setToggleNewItem}
              selectedLeaseStartDate={selectedLeaseStartDate}
              selectedEarlyMoveInDate={selectedEarlyMoveInDate}
              setValidIncentives={setValidIncentives}
              validIncentives={validIncentives}
              isEdit={isEdit}
              incentiveForEdit={incentiveForEdit}
              editIndex={editIndex}
              resetAfterEdit={resetAfterEdit}
            />
          </Subcontent>
        </StyledSubcontentContainer>
      ) : (
        <StyledButton
          label={getTranslatedString(
            'landlordPortal.leaseCreatorV2.leaseIncentivesPage.addIncentive'
          )}
          onClick={() => {
            setToggleNewItem(true);
          }}
          size={isMobile ? 'large' : 'default'}
        />
      )}
    </React.Fragment>
  );
};

export { LeaseIncentiveList };
